import { useState, useEffect, useContext } from 'react';

import { getAuth } from 'firebase/auth';

import { getDoc, doc } from 'firebase/firestore';

import { db } from '../../firebase_config';

import { GoodCard } from '../MainPage/GoodsList/GoodCard/GoodCard';
import { useResize } from '../../Components/useResizeHook';

import { UserContext } from '../UserContext';

import { ChevronDoubleLeft } from '../../Components/SvgComponents/ChevronDoubleLeft';
import { ChevronDoubleRight } from '../../Components/SvgComponents/ChevronDoubleRight';
import { ChevronLeft } from '../../Components/SvgComponents/ChevronLeft';
import { ChevronRight } from '../../Components/SvgComponents/ChevronRight';

import RingLoader from 'react-spinners/RingLoader';

export const WishListPage = () => {
  const { wishList } = useContext(UserContext);

  const [currentPage, setCurrentPage] = useState(1);
  const goodsPerPage = useResize();

  const sortedWishList = wishList.reduce(
    (accumulator, currentValue) => {
      if (accumulator[accumulator.length - 1].length === goodsPerPage) {
        accumulator.push([]);
      }

      accumulator[accumulator.length - 1].push(currentValue);
      return accumulator;
    },
    [[]]
  );

  const turnNextPage = () => {
    if (currentPage < sortedWishList.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const turnPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const swipeStartPage = () => {
    setCurrentPage(1);
  };

  const swipeEndPage = () => {
    setCurrentPage(sortedWishList.length);
  };

  return (
    <section className="relative min-h-screen w-full">
      <div className="bg-cover bg-center bg-flasks bg-no-repeat absolute top-0 right-0 bottom-0 left-0">
        <div className="relative w-full h-full flex justify-center items-center">
          <div className="absolute top-0 right-0 bottom-0 left-0 z-10 flex flex-col gap-10 pt-10 md:pt-14 items-center bg-shadowLight">
            <h3 className="font-crimson font-normal text-2xl smart:text-3xl md:text-4xl text-center leading-7 tracking-wider text-font">
              Your Magic List
            </h3>
            <div className="h-96 flex justify-center items-center z-20 flex-wrap gap-4 md:gap-7">
              {wishList.length ? (
                sortedWishList[currentPage - 1].map((good) => <GoodCard key={good.id} data={good} />)
              ) : (
                <RingLoader color={'#F4F4F4'} size={120} />
              )}
            </div>
            <div className="mt-4 md:mt-6 self-center flex gap-3 md:gap-6">
              <button
                className={[
                  'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-300 hover:border-body hover:text-body hover:bg-transparent',
                  currentPage === 1
                    ? 'bg-none border-body text-body cursor-default'
                    : 'bg-body border-transparent text-background',
                ].join(' ')}
                onClick={swipeStartPage}>
                <ChevronDoubleLeft />
              </button>
              <button
                className={[
                  'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-300 hover:border-body hover:text-body hover:bg-transparent',
                  currentPage === 1
                    ? 'bg-none border-body text-body cursor-default'
                    : 'bg-body border-transparent text-background',
                ].join(' ')}
                onClick={turnPreviousPage}>
                <ChevronLeft />
              </button>
              <div className="p-1 rounded-full h-10 w-10 flex justify-center items-center bg-transparent font-poppins leading-5 border bg-body border-body text-background">
                {currentPage}
              </div>
              <button
                className={[
                  'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-300 hover:border-body hover:text-body hover:bg-transparent',
                  currentPage === sortedWishList.length
                    ? 'bg-none border-body text-body cursor-default'
                    : 'bg-body font-poppins border-transparent text-background',
                ].join(' ')}
                onClick={turnNextPage}>
                <ChevronRight />
              </button>
              <button
                className={[
                  'p-1 rounded-full h-10 w-10 flex justify-center items-center font-poppins leading-5 border hover:bg-none duration-300 hover:border-body hover:text-body hover:bg-transparent',
                  currentPage === sortedWishList.length
                    ? 'bg-none border-body text-body cursor-default'
                    : 'bg-body border-transparent text-background',
                ].join(' ')}
                onClick={swipeEndPage}>
                <ChevronDoubleRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
